// src/components/PageWrapper.tsx
import React from 'react'
import useBgc from '../hooks/use-background-color'
import usePreloadImages from '../hooks/use-preload-images'
import { preloadImgs } from '../data/images'

type Props = {
  children: React.ReactNode
  style?: React.CSSProperties
  id?: string
}

const getId = () => (Math.random() * 1000).toFixed(0).toString()

const PageWrapper = ({
  children,
  style = {},
  id = getId(),
}: Props) => {
  useBgc(`general`)
  usePreloadImages(preloadImgs)

  return (
    <div
      className="ld ld-blur-in"
      style={{
        animationDuration: '0.3s',
        width: '100vw',
        height: '100vh',
        ...style,
      }}
      id={id}
    >
      {children}
    </div>
  )
}

export default PageWrapper
